import { Inject, Injectable, InjectionToken, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
const Browser = {
    FIREFOX: {
        name: 'Mozilla Firefox',
        matchingExpression: new RegExp('\\bFirefox\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    OPERA: {
        name: 'Opera',
        matchingExpression: new RegExp('\\b(Opera|OPR)\\/([\\d\\.]*)'),
        versionMatchingGroup: 2
    },
    EDGE: {
        name: 'Microsoft Edge',
        matchingExpression: new RegExp('\\bEdge\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    CHROME: {
        name: 'Google Chrome',
        matchingExpression: new RegExp('\\b(Chrome|CriOS)\\/([\\d\\.]*)'),
        versionMatchingGroup: 2
    },
    SAFARI: {
        name: 'Safari',
        matchingExpression: new RegExp('\\bSafari\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    IE: {
        name: 'Internet Explorer',
        matchingExpression: new RegExp('\\b(MSIE |Trident\\/)([\\d\\.]*)'),
        versionMatchingGroup: 2
    }
};

const Engine = {
    BLINK: {
        name: 'Blink',
        matchingExpression: new RegExp('\\bChrome\\/((2[8-9]|[3-9]\\d*)[\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    WEBKIT: {
        name: 'WebKit',
        matchingExpression: new RegExp('\\bAppleWebKit\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    GECKO: {
        name: 'Gecko',
        matchingExpression: new RegExp('\\bGecko\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    PRESTO: {
        name: 'Presto',
        matchingExpression: new RegExp('\\bPresto\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    TRIDENT: {
        name: 'Trident',
        matchingExpression: new RegExp('\\bTrident\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    EDGE: {
        name: 'Edge',
        matchingExpression: new RegExp('\\bEdge\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    KHTML: {
        name: 'KHTML',
        matchingExpression: new RegExp('\\bKHTML\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    },
    NETFRONT: {
        name: 'NetFront',
        matchingExpression: new RegExp('\\bNetFront\\/([\\d\\.]*)'),
        versionMatchingGroup: 1
    }
};

/**
 * @param {?} version
 * @return {?}
 */
function commonDashToDotVersionTranslator(version) {
    return version.replace('_', '.');
}
/**
 * @param {?} version
 * @return {?}
 */
function windowsVersionTranslator(version) {
    switch (version) {
        case 'NT':
        case 'NT 3.1':
        case 'NT 3.5':
        case 'NT 3.51':
        case 'NT 4.0':
        case '98':
        case '95':
        case '3.2':
        case '3.11': return version;
        case '4.00': return '95';
        case '4.10': return '98';
        case '4.90': return 'ME';
        case 'NT 5.0': return '2000';
        case 'NT 5.1': return 'XP';
        case 'NT 5.2': return 'XP/2003/2003 R2';
        case 'NT 6.0': return 'Vista/2008';
        case 'NT 6.1': return '7/2008 R2';
        case 'NT 6.2': return '8/2012';
        case 'NT 6.3': return '8.1/2012 R2';
        case 'NT 10.0': return '10/2016';
    }
    return '';
}
const OS = {
    WINDOWS_PHONE: {
        name: 'Windows Phone',
        matchingExpression: new RegExp('\\bWindows Phone( OS)? ?([\\d\\.]*)'),
        versionMatchingGroup: 2
    },
    WINDOWS: {
        name: 'Windows',
        matchingExpression: new RegExp('\\bWindows(( NT)? ?[\\d\\.]*)'),
        versionMatchingGroup: 1,
        versionTranslator: windowsVersionTranslator
    },
    IOS: {
        name: 'iOS',
        matchingExpression: new RegExp('\\b(iPad|iPhone|iPod)\\b[^\\)]+ OS ?([\\d\\._]+)'),
        versionMatchingGroup: 2,
        versionTranslator: commonDashToDotVersionTranslator
    },
    MAC: {
        name: 'Mac OS X',
        matchingExpression: new RegExp('\\b(Intel )?Mac OS( X)? ?([\\d\\._]*)'),
        versionMatchingGroup: 3,
        versionTranslator: commonDashToDotVersionTranslator
    },
    ANDROID: {
        name: 'Android',
        matchingExpression: new RegExp('\\bAndroid;? ?([\\d\\.]+)'),
        versionMatchingGroup: 1
    },
    CHROME: {
        name: 'Chrome OS',
        matchingExpression: new RegExp('\\bCrOS ?[^\\b\\) ]* ([\\d\\.]+)'),
        versionMatchingGroup: 1
    },
    LINUX: {
        name: 'Linux',
        matchingExpression: new RegExp('\\bLinux\\b')
    },
    UNIX: {
        name: 'Unix',
        matchingExpression: new RegExp('\\b(Unix|U)\\b', 'i')
    }
};

const NAVIGATOR_UA = new InjectionToken('userAgent');

const Device = {};

class PlatformInfo {
    /**
     * @param {?} name
     * @param {?=} version
     */
    constructor(name, version = '') {
        this.name = name;
        this.version = version;
    }
    /**
     * @return {?}
     */
    toString() {
        return `${this.name} ${this.version}`.trim();
    }
    /**
     * @param {?} collection
     * @param {?} ua
     * @return {?}
     */
    static from(collection, ua) {
        for (let /** @type {?} */ c of Object.keys(collection)) {
            let /** @type {?} */ collectionIdentifier = (collection[c]);
            if (collectionIdentifier.matchingExpression.test(ua)) {
                return PlatformInfo.extractIdentifierInformation(collectionIdentifier, ua);
            }
        }
        return new PlatformInfo('');
    }
    /**
     * @param {?} identifier
     * @param {?} ua
     * @return {?}
     */
    static extractIdentifierInformation(identifier, ua) {
        let /** @type {?} */ info = new PlatformInfo(identifier.name);
        let /** @type {?} */ matches = identifier.matchingExpression.exec(ua);
        if (identifier.versionMatchingGroup >= 0 &&
            identifier.versionMatchingGroup < matches.length) {
            let /** @type {?} */ version = matches[identifier.versionMatchingGroup].trim();
            if (identifier.versionTranslator)
                version = identifier.versionTranslator(version);
            info.version = version;
        }
        return info;
    }
}

class Platform {
    /**
     * @param {?=} ua
     */
    constructor(ua = window.navigator.userAgent) {
        this.ua = ua;
        /** @private */ this._browser = null;
        /** @private */ //_device: PlatformInfo = null;
        /** @private */ this._engine = null;
        /** @private */ this._os = null;
    }
    /**
     * @return {?}
     */
    get browser() {
        if (this._browser === null)
            this._browser = PlatformInfo.from(Browser, this.ua);
        return this._browser;
    }
    /**
     * @return {?}
     */
    get engine() {
        if (this._engine === null)
            this._engine = PlatformInfo.from(Engine, this.ua);
        return this._engine;
    }
    /**
     * @return {?}
     */
    get os() {
        if (this._os === null)
            this._os = PlatformInfo.from(OS, this.ua);
        return this._os;
    }
    /**
     * @param {?} identifier
     * @return {?}
     */
    is(identifier) {
        let /** @type {?} */ collection = this.getSourceCollection(identifier);
        this.assertValidCollection(collection);
        return this.checkByHierarchy(collection, identifier);
    }
    /**
     * @param {?} identifier
     * @return {?}
     */
    isCompatibleWith(identifier) {
        let /** @type {?} */ collection = this.getSourceCollection(identifier);
        this.assertValidCollection(collection);
        return identifier.matchingExpression.test(this.ua);
    }
    /**
     * @param {?} identifier
     * @return {?}
     */
    versionOf(identifier) {
        if (!identifier.versionMatchingGroup)
            throw 'This platform doesn\'t specify any version in the user-agent information.';
        let /** @type {?} */ matches = identifier.matchingExpression.exec(this.ua);
        if (identifier.versionMatchingGroup < 0 ||
            identifier.versionMatchingGroup >= matches.length)
            return '';
        return matches[identifier.versionMatchingGroup];
    }
    /**
     * @param {?} collection
     * @param {?} identifier
     * @return {?}
     */
    checkByHierarchy(collection, identifier) {
        for (let /** @type {?} */ c of Object.keys(collection)) {
            let /** @type {?} */ collectionIdentifier = (collection[c]);
            if (collectionIdentifier.matchingExpression.test(this.ua)) {
                return collection[c] === identifier;
            }
            if (collection[c] === identifier) {
                return false;
            }
        }
        return false;
    }
    /**
     * @param {?} collection
     * @return {?}
     */
    assertValidCollection(collection) {
        if (!collection)
            throw 'The platform identifier to test is not valid.';
    }
    /**
     * @param {?} identifier
     * @return {?}
     */
    getSourceCollection(identifier) {
        for (let /** @type {?} */ collection of [Browser, Device, Engine, OS]) {
            for (let /** @type {?} */ c in collection) {
                if (collection[c] === identifier) {
                    return collection;
                }
            }
        }
        return null;
    }
}
Platform.ɵfac = function Platform_Factory(t) { return new (t || Platform)(ɵngcc0.ɵɵinject(NAVIGATOR_UA)); };
Platform.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Platform, factory: Platform.ɵfac });
/**
 * @nocollapse
 */
Platform.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NAVIGATOR_UA,] },] },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Platform, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAVIGATOR_UA]
            }] }]; }, null); })();

const defaultUserAgent = window.navigator.userAgent;
class PlatformIdentifierModule {
}
PlatformIdentifierModule.ɵfac = function PlatformIdentifierModule_Factory(t) { return new (t || PlatformIdentifierModule)(); };
PlatformIdentifierModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PlatformIdentifierModule });
PlatformIdentifierModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: NAVIGATOR_UA, useValue: defaultUserAgent },
        Platform
    ] });
/**
 * @nocollapse
 */
PlatformIdentifierModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlatformIdentifierModule, [{
        type: NgModule,
        args: [{
                providers: [
                    { provide: NAVIGATOR_UA, useValue: defaultUserAgent },
                    Platform
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Browser, Engine, OS, Platform, PlatformIdentifierModule, NAVIGATOR_UA as ɵd, commonDashToDotVersionTranslator as ɵa, windowsVersionTranslator as ɵb, defaultUserAgent as ɵc };

